import { Period } from '@/app/models/period';
import { usePeriod } from '@/context/PeriodContext';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// Mocked period data used temporarily for base setup.
// In development, this will be replaced by an API call that fetches the periods.
export const data: Period[] = [
  {
    date: '2025-04-01',
    synchronizedDate: '2025-04-15T10:00:00',
    status: 'SYNCHRONIZED',
  },
  {
    date: '2025-03-01',
    synchronizedDate: '2025-03-10T09:30:00',
    status: 'AUTHORIZED',
  },
  {
    date: '2025-02-01',
    synchronizedDate: '2025-02-12T14:45:00',
    status: 'SYNCHRONIZED',
  },
  {
    date: '2025-01-01',
    synchronizedDate: '2025-01-09T08:00:00',
    status: 'AUTHORIZED',
  },
];

export default function PeriodInitializer() {
  const { selectedPeriod, setSelectedPeriod } = usePeriod();

  useEffect(() => {
    if (!selectedPeriod && data) {
      setSelectedPeriod(data[0]);
    }
  }, [selectedPeriod, setSelectedPeriod]);

  return <Outlet />;
}
